import angular from 'angular';
import LayoutComponent from './layout.component';

const LayoutModule = angular
    .module('control-room.commons.layout.components.layout', [])
    .component('crLayout', LayoutComponent);

export default LayoutModule;
